import life from "../../assets/life.png";
import lifeDead from "../../assets/life_dead.png";
const LifeIndicator = (props) => {
  const a = new Array(props.totalLifes).fill(1);
  return (
    <div
      style={{
        color: "white",
        fontWeight: "600",
      }}
      className="d-flex justify-content-end align-items-end"
    >
      {a.map((d, index) => {
        var image;
        if (index < props.value) {
          image = life;
        } else {
          image = lifeDead;
        }
        return (
          <div className="p-1">
            <img src={image} width="30" alt="life_indicator"></img>
          </div>
        );
      })}
    </div>
  );
};

export default LifeIndicator;
